import { render, staticRenderFns } from "./ApplySuppliersDialog.vue?vue&type=template&id=6052ce06&scoped=true&"
import script from "./ApplySuppliersDialog.vue?vue&type=script&lang=ts&"
export * from "./ApplySuppliersDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ApplySuppliersDialog.vue?vue&type=style&index=0&id=6052ce06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6052ce06",
  null
  
)

export default component.exports